/* ==========================================================================
   percent-adjust.js
   Alpine component for the standalone Percent Adjust Calculator.

   Replaces the Jotform version. Formula (from the Jotform calculation
   widget): % Correction = ((Proper Flow Rate - Displayed Flow Rate) /
   Proper Flow Rate) * 100

   Much simpler than chem-compat/kfactor — no data file to fetch, just a
   live computed value off two number inputs. Still registers via
   Alpine.data() for the same reason: works with x-data="percentAdjust()"
   wherever it's mounted, no jQuery, no DOM query library.
   ========================================================================== */

document.addEventListener('alpine:init', () => {
  Alpine.data('percentAdjust', () => ({
    displayed: '',
    proper: '',

    clearFields() {
      this.displayed = '';
      this.proper = '';
    },

    get hasBothValues() {
      return this.displayed !== '' && this.proper !== '';
    },

    get isDivideByZero() {
      return this.proper !== '' && parseFloat(this.proper) === 0;
    },

    get hasValidInputs() {
      const d = parseFloat(this.displayed);
      const p = parseFloat(this.proper);
      return !isNaN(d) && !isNaN(p) && p !== 0;
    },

    get percentCorrection() {
      if (!this.hasValidInputs) return null;
      const d = parseFloat(this.displayed);
      const p = parseFloat(this.proper);
      return ((p - d) / p) * 100;
    },

    get formattedResult() {
      const result = this.percentCorrection;
      if (result === null) return '—';
      const sign = result > 0 ? '+' : '';
      return sign + result.toFixed(2) + '%';
    },
  }));
});
